import { render } from "./CreatorsTable.vue?vue&type=template&id=0ed3c356&scoped=true"
import script from "./CreatorsTable.vue?vue&type=script&lang=ts"
export * from "./CreatorsTable.vue?vue&type=script&lang=ts"

import "./CreatorsTable.vue?vue&type=style&index=0&id=0ed3c356&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ed3c356"

export default script